export default __webpack_public_path__ + "static/media/Ganeshchaturti4.41dc224f.JPG";